<mat-form-field 
  appearance="outline"
  floatLabel="always"
  id="search-select-component-root"
  [ngClass]="{'search-select-disabled': disabled}"
>
  <div class="search-select-icon" matPrefix>
    <mat-icon>search</mat-icon>
  </div>
  <input
    type="text"
    placeholder="{{placeholder}}"
    matInput
    [formControl]="control"
    [matAutocomplete]="auto"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="changeSelect()"
    id="search-select"
    #searchSelect
    [displayWith]="displaySelectorDataLabel"
  >
    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
      {{ option.label }}
    </mat-option>
  </mat-autocomplete>
  <mat-error>{{ errorMessage }}</mat-error>
</mat-form-field>
